import _slicedToArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// Copied from Kitt
// https://github.com/Typeform/kitt/blob/05d879218730c3562ab6a47329e5e12b4e2acd35/src/components/avatar/avatar.tsx#L84
export var getInitials = function getInitials() {
  var fullName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var names = fullName.split(' ');
  var _names = _slicedToArray(names, 1),
    firstName = _names[0];
  var lastName = names.length > 1 && names[names.length - 1];
  return lastName ? firstName[0] + lastName[0] : firstName[0];
};